<app-in-navbar></app-in-navbar>
<router-outlet></router-outlet>
<app-in-footer></app-in-footer>
